import { createActionCreator } from '@pressreader/appstore';
import type { IArticle } from '@pressreader/content-types';
import { IPoint } from '@pressreader/geometry';
import type { ArticleCollections, IArticleSharePreview, ShareProvider } from '@pressreader/social-types';

import { MODULE_NAME } from '../../constants';
import { type ArticleActionPayload } from '../../types/article.action.payload';

const prefix = `${MODULE_NAME}/share/`;

export const loadBookmarksForArticleBegan = createActionCreator<ArticleActionPayload>(`${prefix}load-bookmarks-for-article-began`);

export const loadBookmarksForArticleDone = createActionCreator<{
    articleId: string;
    bookmarks: ArticleCollections[];
}>(`${prefix}load-bookmarks-for-article-done`);

export const loadBookmarksForArticleFailed = createActionCreator<{
    articleId: string;
    error: unknown;
}>(`${prefix}load-bookmarks-for-article-failed`);

export const saveToCollectionRequestAction = createActionCreator<{
    articleId: IArticle['id'];
    primaryArticleId: IArticle['primaryArticleId'];
    bookmark: ArticleCollections | null;
    parentMenuId?: string;
    center?: IPoint;
}>(`${prefix}save-to-collection-request`);

export const openArticleShareMenuAction = createActionCreator<{
    articleId: string;

    center?: IPoint;

    parentMenuId?: string;
}>(`${prefix}open-article-share-menu`);

export const resetBookmarksAction = createActionCreator(`${prefix}reset-bookmarks`);

export const loadShareInfoForArticleDone = createActionCreator<{
    articleId: string;

    preview: IArticleSharePreview;

    /** Supported sharing providers */
    supported: ShareProvider[];
}>(`${prefix}load-share-info-for-article-done`);

export const shareToRequestAction = createActionCreator<{
    articleId: string;

    shareProvider: ShareProvider;
}>(`${prefix}share-to-request`);
